const ContactCategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-category" */ '@/pages/base-info/crm/contact-category/index.vue'
  )
const CreateContactCategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-category" */ '@/pages/base-info/crm/contact-category/create.vue'
  )
const EditContactCategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-category" */ '@/pages/base-info/crm/contact-category/edit.vue'
  )

export default {
  path: 'contact-category',
  meta: {
    label: 'category',
    auth: 'category'
  },
  component: {
    name: 'Category',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCrmContactCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ContactCategory
    },
    {
      name: 'BaseInfoCreateCrmContactCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContactCategory
    },
    {
      name: 'BaseInfoEditCrmContactCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContactCategory,
      props: true
    }
  ]
}
